import React from 'react';
import PropTypes from 'prop-types';
import styles from './index.css';
import CommentUrl from './commentUrl';
import Vote from './vote';
import ShareIconBox from './shareIconBox';
import errorBoundary from '@ifeng-fe/errorBoundary';
import { getCommentCount } from '@ifeng-fe/container_content/common/client/services/api';

class ShareBox extends React.PureComponent {
    static propTypes = {
        docData: PropTypes.object,
        interact: PropTypes.object,
    };

    state = {
        allowComment: false,
    };

    async componentDidMount() {
        const { commentUrl } = this.props.docData;

        try {
            const { allow_comment } = await getCommentCount(commentUrl);

            this.setState({
                allowComment: allow_comment !== -1,
            });
        } catch (e) {
            console.error(e);
        }
    }

    /**
     * 渲染网页布局
     */
    render() {
        const { allowComment } = this.state;
        const { docData, interact } = this.props;
        const { title, summary, commentUrl, imagesInContent } = docData;

        return (
            <div>
                <ul className={styles.mod_share}>
                    {allowComment && (
                        <React.Fragment>
                            <li className={styles.line01} />
                            <CommentUrl docData={docData} />
                        </React.Fragment>
                    )}
                    {!interact?.isCloseShare && (
                        <>
                            <li className={styles.line01} />
                            <ShareIconBox docData={docData} />
                        </>
                    )}
                    <li className={styles.line01} />
                    <Vote docData={docData} url={commentUrl} interact={interact} />
                </ul>
            </div>
        );
    }
}

export default errorBoundary(ShareBox);
